/**
 * Подпись ученика для кабинета преподавателя.
 * Своё имя (alias) важнее профиля; логин — запасной вариант.
 */
export function studentLabel(student) {
  if (!student) return '';
  const alias = (student.alias || '').trim();
  if (alias) return alias;
  const profile = [student.last_name, student.first_name].filter(Boolean).join(' ').trim();
  if (profile) return profile;
  return (student.display_name || student.username || '').trim();
}

/** Год сдачи из анкеты, если API его отдал. */
export function examYearLabel(student) {
  return (student?.exam_year || '').trim();
}

/** «Петя, 2027» — то же имя, плюс год сдачи. */
export function studentLabelWithExamYear(student) {
  const label = studentLabel(student);
  const year = examYearLabel(student);
  if (!year) return label;
  return label ? `${label}, ${year}` : year;
}

/** «Петя @darklord99» или просто «Петя», если логин совпадает с подписью. */
export function studentLabelWithLogin(student) {
  const label = studentLabel(student);
  const username = (student?.username || '').trim();
  if (!username) return label;
  if (!label || label === username) return `@${username}`;
  return `${label} @${username}`;
}
